<template>
  <div class="popup form-popup visible" id="new-terminal-popup">
    <div class="popup-box">
      <p class="h2 title line">{{popupData.type === 'add' ? 'Add new' : 'Update' }} LX Terminal</p>
      <form action="#" class="form">

        <div class="field" :class="errorClass('customer')">
          <label class="field-name">Customer</label>
          <Select2 v-model="customer" :options="customersOptions" :placeholder="'Select Customer'"  name="select" class="select select-search" data-placeholder="Select Customer" />
          <span class="error-text" v-if="v$.customer.$error">{{errorMessage('customer')}}</span>
        </div>
        <div class="field" :class="errorClass('terminal')">
          <label class="field-name">Terminal Type</label>
          <Select2 v-model="terminal" :options="typeOptions" :placeholder="'Select Terminal Type'"   name="select" class="select select-search" data-placeholder="Select Terminal" />
          <span class="error-text" v-if="v$.terminal.$error">{{errorMessage('terminal')}}</span>
        </div>
        <div class="field" :class="errorClass('moduleId')">
          <label class="field-name">Core Module ID</label>
          <input type="tel" class="form-control" placeholder="Type core module ID" v-model="moduleId">
          <span class="error-text" v-if="v$.moduleId.$error">{{errorMessage('moduleId')}}</span>
        </div>
        <div class="field" :class="errorClass('subscription')">
          <label class="field-name">Active Subscription</label>
          <Select2 v-model="subscription" :options="subscriptionOptions" :placeholder="'Select Subscription'" name="select" class="select select-search" data-placeholder="Select Subscription" />
          <span class="error-text" v-if="v$.subscription.$error">{{errorMessage('subscription')}}</span>
        </div>

        <div class="form-btn-box">
         <span class="btn success no-bg small" @click="closePopup">
          <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-deny/></icon-base>
          <span>Cancel</span>
         </span>
          <button type="button" class="btn success small" @click="actionClick">
            <icon-base width="22" height="21" viewBox="0 0 25 26"><icon-success/></icon-base>
            <span>{{popupData.type === 'add' ? 'CREATE' : 'UPDATE' }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import {mapMutations, mapActions, mapState} from "vuex"
import IconBase from "../../common/IconBase";
import IconDeny from "../../common/icons/IconDeny";
import IconSuccess from "../../common/icons/IconSuccess";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Select2 from "../../Client/MySelect2";

export default {
    name: 'terminal-form',

    setup () {
        return { v$: useVuelidate() }
    },
    data () {
        return {
            customer: '',
            terminal: '',
            moduleId: '',
            subscription: '',
            typeOptions: [],
            subscriptionOptions: [],
            customersOptions: []
        }
    },
    validations() {
        return {
            customer: {required},
            terminal: {required},
            moduleId: {required},
            subscription: {required},
        }
    },
    components: {
        Select2,
        IconSuccess, IconDeny, IconBase
    },

    computed: {
        ...mapState({
            popupData: state => state.popupData,
        }),
        ...mapState('terminals', [
            'terminalTypes',
            'subscriptions',
            'customers'
        ]),
        /*...mapState('customers', [
            'customers',
        ]),*/
    },

    mounted() {
        if (this.popupData.type === 'edit') {
            this.customer = this.popupData.item.client_id;
            this.terminal = this.popupData.item.type_id;
            this.moduleId = this.popupData.item.core_module_id;
            this.subscription = this.popupData.item.subscription_id;
        }

        this.terminalTypes.forEach(item => {
            this.typeOptions.push({
                id: item.id,
                text: item.name
            })
        });

        this.customers.forEach(item => {
            this.customersOptions.push({
                id: item.id,
                text: item.company
            })
        });

         this.subscriptions.forEach(item => {
             this.subscriptionOptions.push({
                 id: item.id,
                 text: item.name
             })
         });
    },

    methods: {
        customersOption() {
        },
        ...mapMutations([
            'switchPopup',
            'setPopupComponent'
        ]),
        ...mapActions('terminals', [
            'loadTerminals',
        ]),
        errorClass(field) {
            return this.v$[field].$error ? 'error-field' : ''
        },
        errorMessage(field) {
            return this.v$[field].$errors[0].$message
        },
        closePopup() {
            this.switchPopup(false);
        },
        actionClick() {
            this.v$.$touch();

            if (this.v$.$error) {
                return false;
            }

            let params = {
                client_id: this.customer,
                type_id: this.terminal,
                core_module_id: this.moduleId,
                subscription_id: this.subscription,
            };

            if (this.popupData.type === 'edit') {
                params.id = this.popupData.item.id
            }

            this.popupData.func(params).then(() => {
                this.switchPopup(false);
                this.loadTerminals();
            });

        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
